import { render, staticRenderFns } from "./SkeletonIdLoader.vue?vue&type=template&id=07b81750&scoped=true&"
import script from "./SkeletonIdLoader.vue?vue&type=script&lang=js&"
export * from "./SkeletonIdLoader.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonIdLoader.vue?vue&type=style&index=0&id=07b81750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b81750",
  null
  
)

export default component.exports